var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import generateUUID from 'syf-js-utilities/helpers/generateUUID';
import HTTPError from './http-error';
var getAuthHeaders = function () {
    var _a;
    var accessToken = sessionStorage.getItem('accessToken');
    var correlationId = (_a = sessionStorage.getItem('correlationId')) !== null && _a !== void 0 ? _a : '';
    return {
        Authorization: "Bearer ".concat(accessToken),
        'X-SYF-Request-CorrelationId': correlationId,
        'X-SYF-Request-TrackingId': generateUUID()
    };
};
/**
 * useFetch hook returns a function that will make syf API calls. It will include required headers including authorization token and session id taken from sessionStorage.
 * @param config An MFE config object that includes apigee host names to use and an error callback in case of HTTP responses other than 200
 * @returns A function that wrapps fetch. This wrapper function automatically adds required headers to syf API calls, it also parses the response.
 */
var useFetch = function (config) {
    function fetchWrapper(url_1, init_1) {
        return __awaiter(this, arguments, void 0, function (url, init, base, addAuth) {
            var fullUrl, _a, headers, rest, contentType, fetchOptions, response, err, text, _e_1;
            var _b;
            if (base === void 0) { base = config.hosts.apigee; }
            if (addAuth === void 0) { addAuth = true; }
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        fullUrl = new URL(url, base);
                        _a = init.headers, headers = _a === void 0 ? {} : _a, rest = __rest(init, ["headers"]);
                        contentType = 'application/json';
                        if (!init.method || ((_b = init.method) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'GET') {
                            contentType = 'text/plain';
                        }
                        fetchOptions = __assign({ mode: 'cors', headers: {
                                'Content-Type': contentType,
                                Accept: 'application/json'
                            } }, rest);
                        if (addAuth) {
                            fetchOptions.headers = __assign(__assign(__assign({}, fetchOptions.headers), headers), getAuthHeaders());
                        }
                        return [4 /*yield*/, fetch(fullUrl.toString(), fetchOptions)];
                    case 1:
                        response = _c.sent();
                        if (!response.ok) {
                            err = new HTTPError(response);
                            config.apiErrorCallback(err);
                            throw err;
                        }
                        if (response.status === 204) {
                            return [2 /*return*/, null];
                        }
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, response.text()];
                    case 3:
                        text = _c.sent();
                        return [2 /*return*/, JSON.parse(text)];
                    case 4:
                        _e_1 = _c.sent();
                        throw new HTTPError(response);
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    return fetchWrapper;
};
export default useFetch;
//# sourceMappingURL=use-fetch.js.map